import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'react-feather';

// Function to scroll on top when link cilcked
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, [pathname]);
  return null;
}


// Menu Link
export const MenuURL = "https://staging1.mslgroup.tech/organic-website/organic-backend/wp-json/wp-api-menus/v2/menus";

// Slick Arrows
export const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
  <button
    {...props}
    className={"slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")}
    aria-hidden="true"
    aria-disabled={currentSlide === 0 ? true : false}
    type="button">
    <ChevronLeft/>
  </button>
);

// Slick Arrows
export const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
  <button
    {...props} className={"slick-next slick-arrow" + (currentSlide === slideCount - 1 ? " slick-disabled" : "")}
    aria-hidden="true"
    aria-disabled={currentSlide === slideCount - 1 ? true : false}
    type="button">
    <ChevronRight/>
  </button>
);